module.exports = __webpack_public_path__ + "assets/img/881587018266_.pic_hd.63fbed11.jpg";